import { useTranslation } from 'react-i18next'
import DetailsTab from '../details/DetailsTab'
import StacktraceTab from '../stacktrace/StacktraceTab'

export const useTabsOptions = () => {
  const { t } = useTranslation(['logs', 'common'])

  return [
    { name: t('common:details'), Component: DetailsTab },
    { name: t('logs:stacktrace'), Component: StacktraceTab }
  ]
}
